import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { useEffect } from "react";
import "./App.css";

import Layout from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Sets from "./pages/Sets";
import Videos from "./pages/Videos";
import Events from "./pages/Events";
import InnerDance from "./pages/InnerDance";
import Releases from "./pages/Releases";
import Community from "./pages/Community";
import PressKit from "./pages/PressKit";
import Reviews from "./pages/Reviews";
import Booking from "./pages/Booking";
import TechRider from "./pages/TechRider";
import Merch from "./pages/Merch";
import Admin from "./pages/Admin";
import { ContentProvider } from "./lib/content";

function App() {
  useEffect(() => {
    document.title = "Inner Pulse — Techno / Hardgroove";
  }, []);

  return (
    <div className="App grain" data-testid="app-root">
      <ContentProvider>
        <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/sets" element={<Sets />} />
            <Route path="/videos" element={<Videos />} />
            <Route path="/events" element={<Events />} />
            <Route path="/inner-dance" element={<InnerDance />} />
            <Route path="/releases" element={<Releases />} />
            <Route path="/community" element={<Community />} />
            <Route path="/press-kit" element={<PressKit />} />
            <Route path="/reviews" element={<Reviews />} />
            <Route path="/booking" element={<Booking />} />
            <Route path="/tech-rider" element={<TechRider />} />
            <Route path="/merch" element={<Merch />} />
            <Route path="/admin" element={<Admin />} />
          </Route>
        </Routes>
      </BrowserRouter>
      </ContentProvider>
      <Toaster
        position="top-center"
        theme="dark"
        toastOptions={{
          style: {
            background: "#0a0a0a",
            color: "#e5e5e5",
            border: "1px solid #2a2a2a",
            fontFamily: "Orbitron, sans-serif",
            fontSize: "0.8rem",
            letterSpacing: "0.05em",
            borderRadius: "0",
          },
        }}
      />
    </div>
  );
}

export default App;
